var exports = {
  "p": "xa15a2ab7--db1334--filter",
};

module.exports = exports;
